<template>
  <div>
    <span>{{tariffName}}</span>
    <span v-if="getTariffEndDate">, {{$t('message.tariff.endDate', {date: getTariffEndDate})}}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TariffCommon',
  computed: {
    ...mapGetters('utils', ['getTariffName', 'getCurrentParams', 'getTariffEndDate']),
    ...mapGetters('payment', ['getPaymentType', 'getLocalPayment']),
    tariffName () {
      return this.getTariffName
    },
    showRtjs () {
      return !this.getLocalPayment && this.getPaymentType === 'rtjs'
    }
  }
}
</script>

<style scoped>

</style>
